export enum Key {
  Enter = 'Enter',
}

export const OFF = 'off';
